import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-67f2da4f")

_pushScopeId("data-v-67f2da4f")
const _hoisted_1 = { class: "office-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "visual" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "group-image",
    src: "https://prod-barry-image.s3.ap-northeast-1.amazonaws.com/officies/riku_entertainment/Barbie%C3%97Barbie_%E5%85%A8%E4%BD%93.jpg"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TalentList = _resolveComponent("TalentList")
  const _component_Usecase = _resolveComponent("Usecase")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_TalentList),
    _createVNode(_component_Usecase)
  ]))
})